<button
	#triggerHost
	class="trigger"
	[class.is-open]="showDropdown()"
	(click)="openDialog()"
	aria-haspopup="dialog"
	[attr.aria-expanded]="showDropdown()"
>
	<span class="icon-vak">
		<app-icon name="user" size="medium" color="secondary-1" />
	</span>
	<span class="label">{{ getRolName(activeRol()!) }}</span>
	<app-icon [name]="showDropdown() ? 'chevron-up' : 'chevron-down'" size="smallest" color="typography-5" />
</button>
